/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";

import {
  useLazyGetAllMainSkillByCategoriesIdQuery,
  useLazyGetAllSkillCategoriesQuery,
  useLazyGetAllSubSkillByMainSkillIdQuery,
} from "../../../app/services/skillCategoriesAPI";

/** Utilities */
import { hasFunctionalPermission } from '../../../utils/authorizeNavigation/authorizeNavigation';
import { setDropDownOptionField } from "../../../utils/FormFields/FieldsSetting/SetFieldSetting";

/** Common Components */
import Buttons from '../../../components/ui/button/Buttons';
import FormCreator from "../../../components/FinalForms/FormCreator";
import DataLoader from "../../../components/ui/dataLoader/DataLoader";

/** Configuration Files */
import addEditInfo from '../position.Data';

/** Common Services & Data Files */
import { securityKey } from '../../../data/SecurityKey';
import SwalAlert from "../../../services/swalService/SwalService";
import ToastService from '../../../services/toastService/ToastService';
import { onResetForm } from "../../../utils/FormFields/ResetForm/handleResetForm";

/** RTK Query */
import { useLazyGetAllSkillQuery } from '../../../app/services/skillAPI';
import { useLazyGetDepartmentQuery } from '../../../app/services/departmentAPI';
import {
  useAddMutation,
  useDeleteJobSkillMutation,
  useLazyGetByIdQuery,
  useUpdateMutation,
} from "../../../app/services/jobTitleAPI";


const AddPosition = (props) => {

  const ref = useRef();

  const [skillList, setSkillList] = useState([]);
  const [formData, setFormData] = useState(addEditInfo);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isSkillLoading, setIsLoading] = useState(false);
  const [positionAppliedSkillId, setPositionAppliedSkillId] = useState(null);
  const [isButtonDisable, setIsButtonDisable] = useState(false);

  const hasAddPermission = hasFunctionalPermission(securityKey.ADDJOBPOSITION);
  const hasEditPermission = hasFunctionalPermission(securityKey.EDITJOBPOSITION);

  const { formSetting } = addEditInfo;

  const [add, {
    isLoading: isAddLoading,
    isSuccess: isAddSuccess,
    data: isAddData
  }] = useAddMutation();

  const [update, {
    isLoading: isUpdateLoading,
    isSuccess: isUpdateSuccess,
    data: isUpdateData
  }] = useUpdateMutation();

  const [getDepartment, {
    isFetching: isDepartmentFetching,
    isSuccess: isDepartmentFetched,
    data: departmentData
  }] = useLazyGetDepartmentQuery();

  const [getAllSkill, {
    isFetching: isSkillFetching,
    isSuccess: isAllSkillsFetched,
    data: skillData
  }] = useLazyGetAllSkillQuery();

  useEffect(() => {
    getDepartment();
    // getAllSkill();
    // getAllSkillCategories();
  }, []);

  useEffect(() => {
    if (!props.isEdit) {
      if (hasAddPermission && hasAddPermission.hasAccess === true) {
        formSetting.isViewOnly = false;
        setIsButtonDisable(false);
      }
    }
    else if (props.isEdit) {
      if (hasEditPermission.isViewOnly === true) {
        formSetting.isViewOnly = true;
        setIsButtonDisable(true)
      }
    }
  }, [hasAddPermission, hasEditPermission, formSetting.isViewOnly]);

  useEffect(() => {
    onreset();
    if (props.data && props.isDetailPage) {
      const newForm = { ...addEditInfo }
      newForm.initialState = {
        departmentId: props.data.departmentId || 0,
        positionName: props.data.positionName,
        description: props.data.description,
        isEnable: props.data.isEnable,
      }
      setFormData(newForm);
    }

  }, [props.data && props.isDetailPage]);


  const Add = () => {
    let formData = ref.current.getFormData();

    if (formData && !props.positionAppliedId) {
      const requestData = {
        ...formData,
        departmentId:
          formData.departmentId && typeof formData.departmentId === "object"
            ? formData.departmentId.value
            : formData.departmentId,
        // skillList,
      };
      add(requestData);
    } else if (formData && props.positionAppliedId) {
      const requestData = {
        ...formData,
        positionAppliedId: props.positionAppliedId,
        departmentId:
          formData.departmentId && typeof formData.departmentId === "object"
            ? formData.departmentId.value
            : formData.departmentId,
        // skillList,
      };
      update(requestData);
    }
  };

  useEffect(() => {
    if (isAddSuccess && isAddData) {
      if (isAddData.errorMessage.includes("exists")) {
        ToastService.warning(isAddData.errorMessage);
        return;
      }
      if (props.onSuccess) {
        props.onSuccess();
      }
      onreset();
      // setskillListData([
      //   {
      //     skillCategoriesId: "",
      //     mainSkillId: "",
      //     subSkillId: [],
      //     mainSkillOptions: [],
      //     subSkillOptions: [],
      //   },
      // ]);
      ToastService.success(isAddData.errorMessage);
    }
  }, [isAddSuccess, isAddData]);

  useEffect(() => {
    if (!isDepartmentFetching && isDepartmentFetched && departmentData) {
      setDropDownOptionField(
        departmentData,
        "departmentId",
        "departmentName",
        addEditInfo,
        "departmentId"
      );
    }
  }, [isDepartmentFetching, isDepartmentFetched, departmentData]);

  useEffect(() => {
    if (isUpdateSuccess && isUpdateData) {
      props.onSidebarClose();
      ToastService.success(isUpdateData.errorMessage);
    }
  }, [isUpdateSuccess, isUpdateData]);

  //** Reset Data */
  const onreset = () => {
    let form = { ...formData };
    onResetForm(form, setFormData, null);
  };

  //** Back to List */
  const backToList = () => {
    onreset();
    if (!props.isDetailPage) {
      props.onSidebarClose();
    } else if (props.isDetailPage) {
      // navigate("/Position");
      props.onSidebarClose();
    }
  };


  return (
    <div className='mt-3'>
      <form>
        <div className="row">
          <FormCreator
            config={formData}
            ref={ref} {...formData}
            // onActionChange={formActionHandler}
          />
        </div>
      </form>
      <div className="row mt-3">
        <div className="col-12">
          <div className="form-btn d-flex justify-content-end">
            <Buttons
              buttonTypeClassName="btn dark-btn"
              onClick={backToList}
              buttonText="Cancel"
            />
            <Buttons
              onClick={Add}
              isDisable={isButtonDisable}
              buttonTypeClassName="btn theme-btn ml-5"
              isLoading={isAddLoading || isUpdateLoading}
              buttonText={`${props.isEdit ? 'Update' : 'Add'}`}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddPosition;
